import React from 'react';
import { motion } from 'framer-motion';
import { Mountain, ExternalLink, Users, MapPin, ArrowRight, Compass, Mic, Globe } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PageTransition } from '../components/PageTransition';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
export function EndsAdventuresPage() {
  return <PageTransition data-id="element-267" data-mp="7di9ai7ue8r0">
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden min-h-[70vh] flex items-center" data-id="element-268" data-mp="7ge7m7nlqzfz">
        <div className="absolute inset-0" data-id="element-269" data-mp="2hbcpg1c69lq">
          <video autoPlay muted loop playsInline className="w-full h-full object-cover" data-id="element-270" data-mp="hd0rou83tmgy">
            <source src="https://endsadventures.com/wp-content/uploads/2025/05/2026-DESKTOP-web_banner_-_1920_x_1080_hd-720p.mp4" type="video/mp4" data-id="element-271" data-mp="cfh9xkc76rk9" />
          </video>
          <div className="absolute inset-0 bg-dark-900/60" data-id="element-272" data-mp="1nuw64lwl1feb"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-273" data-mp="25emgx3750c99">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-274" data-mp="2ace6vro81oat">
            <span className="text-gold-500 font-medium tracking-wider uppercase text-sm mb-4 block" data-id="element-275" data-mp="1mp635e6fynaw">
              Est. 2012
            </span>
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-276" data-mp="1rlda9aakq4uf">
              Ends <span className="text-gold-500" data-id="element-277" data-mp="20frn767mt3ad">Adventures</span>
            </h1>
            <p className="text-2xl font-serif text-white/90 mb-4" data-id="element-278" data-mp="20hw18gz8viod">
              Exercise Your Faith
            </p>
            <p className="text-xl text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-279" data-mp="17zgxp6rbfx4t">
              Christ-Centered Adventure Events. #PrayGoRepeat
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-280" data-mp="2b8jnnqhy44vy">
              <a href="https://endsadventures.com/" target="_blank" rel="noopener noreferrer" data-id="element-281" data-mp="26arukt5kecq6">
                <Button size="lg" rightIcon={<ExternalLink className="w-5 h-5" data-id="element-283" data-mp="2g37bdn54kv9h" />} data-id="element-282" data-mp="2g0kwf2fwndh8">
                  Choose Your Adventure
                </Button>
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-24 bg-dark-700" data-id="element-284" data-mp="21d9kgzft9rgl">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-285" data-mp="21a3xpqunn1o1">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-286" data-mp="1x91vr29csbid">
            <Mountain className="w-12 h-12 text-gold-500 mx-auto mb-6" data-id="element-287" data-mp="3g89i3ag5rgdx" />
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6" data-id="element-288" data-mp="3l84ajifl0e13">
              Encounter God in the Wild
            </h2>
            <p className="text-lg text-white/80 leading-relaxed mb-8" data-id="element-289" data-mp="36co9uukhxjvq">
              Since 2012, Ends Adventures has been a ministry dedicated to using
              outdoor adventure as a catalyst to strengthen faith and build
              authentic community. We believe that stepping away from the noise
              of everyday life and into the beauty of creation provides a unique
              space to hear God's voice, face challenges with resilience, and
              forge deep, lasting relationships with fellow believers.
            </p>
            <div className="w-24 h-1 bg-gold-500 mx-auto rounded-full" data-id="element-290" data-mp="ltinn8ctnf7s"></div>
          </motion.div>
        </div>
      </section>

      {/* Crew Photo Section */}
      <section className="py-24 bg-dark-800 border-t border-dark-600" data-id="element-291" data-mp="qla76yxk8kof">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-292" data-mp="2z1td6c56k6ks">
          <div className="text-center mb-10" data-id="element-293" data-mp="2u28cnxad3q5y">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-294" data-mp="2u0dtaneqo63z">
              Meet the Crew
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto" data-id="element-295" data-mp="2p4oxmv5ub9cy">
              One family having fun, working hard. The heart and soul behind
              every adventure.
            </p>
          </div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="rounded-2xl overflow-hidden border border-dark-500 shadow-2xl" data-id="element-296" data-mp="3htdw0mfih0l0">
            <img src="https://cdn.magicpatterns.com/uploads/nVBgdWjoJsmw8EM2yFdSDU/EndsCrew_2024_WithErin1-scaled-e1743166037452.jpg" alt="Ends Adventures Crew — One Family Having Fun Working Hard" className="w-full h-auto object-cover" data-id="element-297" data-mp="4dep0uqnc8ng" />
          </motion.div>
        </div>
      </section>

      {/* What They Offer Section */}
      <section className="py-24 bg-dark-800 border-t border-dark-600" data-id="element-298" data-mp="gu7fdvn8iy85">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-299" data-mp="lu27g2iqxtus">
          <div className="text-center mb-16" data-id="element-300" data-mp="ls8wwc50iphi">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-301" data-mp="qty7xrs8j35l">
              Adventure Awaits
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto" data-id="element-302" data-mp="utgwcxj9lwd6">
              Whether you're looking for a physical challenge or a spiritual
              retreat, there's an adventure designed to stretch your faith.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-303" data-mp="19k68q38gphim">
            {[{
            title: 'Hiking Expeditions',
            description: 'Multi-day treks through breathtaking landscapes that challenge the body and renew the spirit.',
            icon: <Mountain className="w-6 h-6 text-gold-500" data-id="element-304" data-mp="jwajkufa6ab2" />
          }, {
            title: 'Mission Trips',
            description: 'Purpose-driven travel combining outdoor adventure with serving communities in need.',
            icon: <Globe className="w-6 h-6 text-gold-500" data-id="element-305" data-mp="17lcznxu9nv3g" />
          }, {
            title: 'Retreats',
            description: 'Immersive weekend getaways focused on spiritual rest, teaching, and fellowship.',
            icon: <Compass className="w-6 h-6 text-gold-500" data-id="element-306" data-mp="1hj0xwxr2zkqd" />
          }, {
            title: 'Community Events',
            description: 'Local gatherings and day trips designed to build relationships and encourage one another.',
            icon: <Users className="w-6 h-6 text-gold-500" data-id="element-307" data-mp="3ed4d061qzey2" />
          }].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} data-id="element-308" data-mp="1tuaacsayesg8" data-mpi={index}>
                <Card className="p-6 h-full bg-dark-700 border-dark-600 hover:border-gold-500/50 transition-colors" data-id="element-309" data-mp="1f4w2jon10j2y">
                  <div className="w-12 h-12 rounded-full bg-dark-800 border border-dark-500 flex items-center justify-center mb-4" data-id="element-310" data-mp="115mjmh7frava">
                    {item.icon}
                  </div>
                  <h3 className="text-xl font-serif font-bold text-white mb-3" data-id="element-311" data-mp="2vjdrpca49mom">
                    {item.title}
                  </h3>
                  <p className="text-white/80 text-sm leading-relaxed" data-id="element-312" data-mp="30gw2z9blwdzs">
                    {item.description}
                  </p>
                </Card>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Connection to 3 Doves Section */}
      <section className="py-24 bg-dark-700 border-t border-dark-600" data-id="element-313" data-mp="1ei8yu363skow">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-314" data-mp="19jz41toajm3t">
          <Card className="p-8 md:p-12 bg-dark-800 border-gold-500/30 relative overflow-hidden" data-id="element-315" data-mp="19jpeg775rgyn">
            <div className="absolute top-0 right-0 w-64 h-64 bg-gold-500/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-316" data-mp="14m5zf52mz05n"></div>

            <div className="relative z-10 flex flex-col md:flex-row items-center gap-8 text-center md:text-left" data-id="element-317" data-mp="vjwpagba58ss">
              <div className="w-24 h-24 rounded-full bg-dark-700 border-2 border-gold-500 flex items-center justify-center flex-shrink-0" data-id="element-318" data-mp="qlmx8ekuqobe">
                <Mic className="w-10 h-10 text-gold-500" data-id="element-319" data-mp="2pxpctdqcuyjs" />
              </div>

              <div data-id="element-320" data-mp="2l05ua1mmjzm1">
                <h3 className="text-2xl font-serif font-bold text-white mb-3" data-id="element-321" data-mp="2kzw52g9elwhe">
                  Hear the Story on 3 Doves
                </h3>
                <p className="text-white/80 leading-relaxed mb-6" data-id="element-322" data-mp="2xhgpuonusdqs">
                  Justin Hanneken, Executive Director of Ends of Earth
                  Adventures, joined Jason on the 3 Doves Podcast to share how
                  adventure and faith collide. Listen to his incredible journey
                  of stepping into the unknown where God does His best work.
                </p>
                <Link to="/podcasts" data-id="element-323" data-mp="2eim9xccnl791">
                  <Button variant="outline" rightIcon={<ArrowRight className="w-4 h-4" data-id="element-325" data-mp="2jhflgz8dqo6k" />} data-id="element-324" data-mp="2ejnlrj1htxrt">
                    Listen to Episodes 3 & 4
                  </Button>
                </Link>
              </div>
            </div>
          </Card>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 relative overflow-hidden bg-dark-800" data-id="element-326" data-mp="2tbhk20nh6lf">
        <div className="absolute inset-0 bg-gold-600/5" data-id="element-327" data-mp="2rid8tdieygl"></div>
        <div className="max-w-4xl mx-auto px-4 text-center relative z-10" data-id="element-328" data-mp="pon0q5ugfu2g">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-329" data-mp="uohsscpyupp3">
            Ready to Step Out?
          </h2>
          <p className="text-xl text-white/80 mb-10 max-w-2xl mx-auto" data-id="element-330" data-mp="zgj33t3kq6ch">
            Discover upcoming events, read stories of impact, and find out how
            you can exercise your faith with Ends Adventures.
          </p>
          <a href="https://endsadventures.com/" target="_blank" rel="noopener noreferrer" className="inline-block" data-id="element-331" data-mp="6sn4giug24d2">
            <Button size="lg" rightIcon={<ExternalLink className="w-5 h-5" data-id="element-333" data-mp="gr2xird17np7" />} data-id="element-332" data-mp="go7157gu172v">
              Visit Ends Adventures
            </Button>
          </a>
        </div>
      </section>
    </PageTransition>;
}